"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const formik_1 = require("formik");
const react_1 = require("react");
const References_1 = require("../../data/constants/References");
const DispatchContext_1 = require("../context/DispatchContext");
const Button_1 = __importDefault(require("../elements/Button"));
const CloseButton_1 = __importDefault(require("../elements/CloseButton"));
const Label_1 = __importDefault(require("../elements/Label"));
const Select_1 = __importDefault(require("../elements/Select"));
const FormikInput_1 = __importDefault(require("../elements/formik/FormikInput"));
const Events_1 = __importDefault(require("../utility/Events"));
const ModalStyle_1 = require("./ModalStyle");
const ml_spectra_processing_1 = require("ml-spectra-processing");
const useSpectraPerNucleus_1 = __importDefault(require("../hooks/useSpectraPerNucleus"));
const Yup = __importStar(require("yup"));
const Message_1 = __importDefault(require("../elements/Message"));
const labelStyle = {
    label: { flex: 4, fontWeight: '500' },
    wrapper: { flex: 8, display: 'flex', alignItems: 'center' },
    container: { padding: '5px 0' },
};
const inputStyle = {
    input: {
        padding: '5px',
    },
};
const baseList = [{ key: 1, value: 'manual', label: 'Manual' }];
const DEFAULT_OPTIONS = {
    from: -1,
    to: 1,
    nbPeaks: 1,
    targetX: 0,
};
const schemaValidation = Yup.object({
    from: Yup.number().required(),
    to: Yup.number().required(),
    nbPeaks: Yup.number().required(),
    targetX: Yup.number().required(),
});
function checkSpectra(options, spectra) {
    const { from, to } = options;
    for (const spectrum of spectra) {
        const { data: { x }, } = spectrum;
        const min = x[0];
        const max = x.at(-1);
        if (from < min || to > max) {
            throw new Error('Some spectra do not have data in the selected range');
        }
        if (Math.abs((0, ml_spectra_processing_1.xFindClosestIndex)(x, from) - (0, ml_spectra_processing_1.xFindClosestIndex)(x, to)) < 10) {
            throw new Error('The selected range is too small to provide accurate results');
        }
    }
}
function checkOptions(options) {
    const returnedOptions = { ...options };
    if (options.from > options.to) {
        returnedOptions.to = options.from;
        returnedOptions.from = options.to;
    }
    return returnedOptions;
}
function getList(nucleus) {
    if (!References_1.REFERENCES?.[nucleus]) {
        return [];
    }
    const list = Object.entries(References_1.REFERENCES[nucleus]).map((item) => ({
        value: item[0],
        label: item[0],
    }));
    return baseList.concat(list);
}
function AlignSpectraModal({ onClose = () => null, nucleus, }) {
    const spectra = (0, useSpectraPerNucleus_1.default)();
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const [options, setOptions] = (0, react_1.useState)(DEFAULT_OPTIONS);
    const [error, setError] = (0, react_1.useState)('');
    function submitHandler(inputOptions) {
        const options = checkOptions(inputOptions);
        setOptions(options);
        try {
            checkSpectra(options, spectra);
            dispatch({ type: 'ALIGN_SPECTRA', payload: options });
            onClose();
        }
        catch (error) {
            const message = error.message;
            setError(message);
        }
    }
    (0, react_1.useEffect)(() => {
        function handler(event) {
            const [from, to] = event.range;
            setOptions((prevOptions) => ({ ...prevOptions, from, to }));
        }
        Events_1.default.on('brushEnd', handler);
        return () => {
            Events_1.default.off('brushEnd', handler);
        };
    }, []);
    function optionChangeHandler(key) {
        const { delta: targetX = 0, ...otherOptions } = References_1.REFERENCES?.[nucleus]?.[key] || {};
        const value = {
            ...DEFAULT_OPTIONS,
            targetX,
            ...otherOptions,
        };
        setOptions(value);
        setError('');
    }
    const List = getList(nucleus);
    return ((0, jsx_runtime_1.jsx)("div", { css: ModalStyle_1.ModalStyles, children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { initialValues: options, enableReinitialize: true, onSubmit: submitHandler, validationSchema: schemaValidation, validate: () => setError(''), children: ({ submitForm }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "header handle", children: [(0, jsx_runtime_1.jsx)("span", { children: "Spectra calibration" }), (0, jsx_runtime_1.jsx)(CloseButton_1.default, { onClick: onClose, className: "close-bt" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "inner-content", style: { flex: 1, minHeight: '220px' }, children: [error && (0, jsx_runtime_1.jsx)(Message_1.default, { type: "error", children: error }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Options", style: labelStyle, children: (0, jsx_runtime_1.jsx)(Select_1.default, { items: List, style: { width: '100%', height: 30 }, onChange: optionChangeHandler }) }), (0, jsx_runtime_1.jsxs)(Label_1.default, { title: "Range", style: labelStyle, children: [(0, jsx_runtime_1.jsx)(Label_1.default, { title: "From", children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "from", type: "number", style: inputStyle }) }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "To", style: { label: { padding: '0 10px' } }, children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "to", type: "number", style: inputStyle }) })] }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Number of Peaks", style: labelStyle, children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "nbPeaks", type: "number", style: inputStyle }) }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Target PPM", style: labelStyle, children: (0, jsx_runtime_1.jsx)(FormikInput_1.default, { name: "targetX", type: "number", style: inputStyle }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "footer-container", children: (0, jsx_runtime_1.jsx)(Button_1.default.Done, { onClick: submitForm, children: "Done" }) })] })) }) }));
}
exports.default = AlignSpectraModal;
